<template>
    <div style="display: flex; align-content: space-around; flex-direction: column; flex-wrap: wrap;">
        <div id="g-reCaptcha"></div>
        <p style="font-size: medium; color: red;" v-if="captchaError">{{ captchaErrorText }}</p>
    </div>
</template>

<script>

export default {
    name: 'ReCaptcha',
    props: {
        captchaError: Boolean,
        captchaErrorText: String,
        step: Number
    },
    data () {
        return {
            reCaptchaToken: null,
            reCaptchaDetails: ''
        }
    },
    mounted () {
        this.loadCaptchaScript()
        let recaptchaScriptIsReady = false
        const nestedThis = this
        const checkInterval = setInterval(function () {
            /* eslint-disable-next-line */
            if (grecaptcha && grecaptcha.enterprise && grecaptcha.enterprise.render) {
                recaptchaScriptIsReady = true
                clearInterval(checkInterval)
                nestedThis.initializeCaptcha()
            }
            return recaptchaScriptIsReady
        }, 500)
    },
    methods: {
        async loadCaptchaScript () {
            const script = document.createElement('script')
            script.src = 'https://www.google.com/recaptcha/enterprise.js'
            script.defer = true
            script.onload = () => this.initializeCaptcha()
            document.head.appendChild(script)
        },
        async initializeCaptcha () {
            const container = this.$el.querySelector('#g-reCaptcha')
            /* eslint-disable-next-line */
            const widgetId1 = grecaptcha.enterprise.render(container, {
                /* eslint-disable-next-line */
                'sitekey': '6LcPSJQpAAAAAKacEvY9IkyIYj3v1_CdEYnBZlek',
                /* eslint-disable-next-line */
                'theme': 'light',
                /* eslint-disable-next-line */
                'callback': this.verifyReCaptcha
            })
            this.reCaptchaDetails = widgetId1
        },
        async verifyReCaptcha () {
            /* eslint-disable-next-line */
            const token = grecaptcha.enterprise.getResponse(this.reCaptchaDetails)
            if (token) {
                this.emitRecaptchaToken(token)
                this.captchaError = false
                this.reCaptchaToken = token
            }
            if (this.step === 2) this.$emit('SubmitGetOtp')
        },
        emitRecaptchaToken (token) {
            this.$emit('GetToken', token)
        },
        resetCaptcha () {
            /* eslint-disable-next-line */
            grecaptcha.enterprise.reset(this.reCaptchaDetails)
        }
    }
}
</script>

<style lang="scss">
</style>
